import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

import { atConfig } from './AT'
import { auConfig } from './AU'
import { beConfig } from './BE'
import { deConfig } from './DE'
import { esConfig } from './ES'
import { fiConfig } from './FI'
import { frConfig } from './FR'
import { gbConfig } from './GB'
import { grConfig } from './GR'
import { ieConfig } from './IE'
import { itConfig } from './IT'
import { jpConfig } from './JP'
import { nlConfig } from './NL'
import { ptConfig } from './PT'
import { seConfig } from './SE'
import { skConfig } from './SK'
import { usConfig } from './US'
import type { FooterConfig } from './types'

export const footerConfigs: Partial<Record<MarketCountryCode, FooterConfig>> = {
  AT: atConfig,
  AU: auConfig,
  BE: beConfig,
  DE: deConfig,
  ES: esConfig,
  FI: fiConfig,
  FR: frConfig,
  GB: gbConfig,
  GR: grConfig,
  IE: ieConfig,
  IT: itConfig,
  JP: jpConfig,
  NL: nlConfig,
  PT: ptConfig,
  SE: seConfig,
  SK: skConfig,
  US: usConfig,
}
